import { header } from 'utils/auth';
import { request } from 'utils/request';

const TEST_PLAN_DAY_ENDPOINT =
  '/api/v2/dealer-settings/nurturing-plan/executions/test-plan-day';

const jsonHeaders = () =>
  new Headers({
    'Content-Type': 'application/json',
    Authorization: header(),
  });

export type TestPlanDayResponse = {
  job_id: string;
  dealer_id: string;
  plan_day: number;
  previous_days_validated: number;
};

export async function testPlanDay(
  dealerId: string,
  planDay: number,
): Promise<TestPlanDayResponse> {
  const response: any = await request(TEST_PLAN_DAY_ENDPOINT, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ dealer_id: dealerId, plan_day: planDay }),
  });

  if (!response) {
    throw new Error('Failed to queue nurturing plan day test');
  }

  const status = response?.statusCode ?? response?.status;
  if (typeof status === 'number' && status >= 400) {
    throw new Error(response?.message || 'Failed to queue nurturing plan day test');
  }

  const body = response?.body ?? response?.data ?? response;
  if (!body?.job_id) {
    throw new Error('Test plan day response missing job_id');
  }

  return body as TestPlanDayResponse;
}

const NurturingPlanExecutionApiService = { testPlanDay };
export default NurturingPlanExecutionApiService;
